module.exports = __webpack_public_path__ + "static/media/Tick.59cebcef.svg";